import { useField } from 'formik'
import TextareaAutosize from 'react-textarea-autosize'

import './Inputs.scss'

const TextAreaInput = ({
  children,
  customOnBlur,
  allowUntouchedValidation = false,
  ...props
}: any) => {
  const [field, meta] = useField(props)

  let fieldData = {
    ...field
  }

  if (customOnBlur) {
    fieldData = {
      ...fieldData,
      onBlur: (event: React.FocusEvent<HTMLInputElement>) => {
        field.onBlur(event)
        customOnBlur()
      }
    }
  }

  return (
    <>
      <div
        className={`textarea-input-old ${
          (allowUntouchedValidation || meta.touched) && meta.error && 'error'
        }`}
      >
        <TextareaAutosize className={`textarea-input-old__input`} {...props} {...fieldData} />
        {children}
        {(allowUntouchedValidation || meta.touched) && meta.error && (
          <div className='validation-error'>
            <div className='validation-error__icon'></div>
            {meta.error}
          </div>
        )}
      </div>
    </>
  )
}

export default TextAreaInput
